module.exports = __webpack_public_path__ + "img/truck2.9e219ce3.webp";